import React from 'react';
import { Outlet } from 'react-router-dom';
import LoaderScreen from './components/loaders/LoaderScreen';
import { useAuthStore, AuthState } from './core/store/auth.store';


const Root: React.FC = () => {
  // 🔹 subscribirse a los isLoading de los stores
  const isLoginLoading = useAuthStore((state: AuthState) => state.isLoading);
//   const isAreaLoading = useAreaStore((state) => state.isLoading);
//   const isChannelLoading = useChannelStore((state) => state.isLoading);
//   const isPaginationLoading = usePaginationStore((state) => state.isLoading);
//   const isParameterLoading = useParameterStore((state) => state.isLoading);

  // 🔹 loader global
  const isGlobalLoading = isLoginLoading;
  
  return (
    <>
      {isGlobalLoading  && <LoaderScreen />}
      <Outlet />
    </>
  );
};

export default Root;
